var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9823 11.9911C23.9823 5.36492 18.6173 0 11.9911 0C5.36492 0 0 5.36492 0 11.9911C0 17.9778 4.38786 22.9341 10.1258 23.8401V15.473H7.07032V12.0089H10.1081V9.36196C10.1081 6.35974 11.9023 4.68986 14.6381 4.68986C15.9526 4.68986 17.3205 4.92081 17.3205 4.92081V7.86973H15.8105C14.3183 7.86973 13.8564 8.7935 13.8564 9.73502V11.9911H17.1784L16.6455 15.4552H13.8564V23.8401C19.5944 22.9519 23.9823 17.9778 23.9823 11.9911Z",
    fill: "#4676ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6454 15.4729L17.1784 12.0088H13.8564V9.75267C13.8564 8.81115 14.3183 7.88739 15.8105 7.88739H17.3205V4.93846C17.3205 4.93846 15.9526 4.70752 14.638 4.70752C11.9023 4.70752 10.1081 6.35963 10.1081 9.37962V12.0266H7.07031V15.4729H10.1081V23.8578C10.7121 23.9466 11.3516 23.9999 11.9734 23.9999C12.5951 23.9999 13.2346 23.9466 13.8386 23.8578V15.4729H16.6454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBookIcon);
export default __webpack_public_path__ + "static/media/FaceBookIcon.3f671c40916f0f4135b1681ba47ca3d8.svg";
export { ForwardRef as ReactComponent };